export default {
  state: {
    time: 0,                              // 全局时间戳  误差1秒
    questions_time: null,                 // 试卷时间
    timer_bol: false,                     // 是否打开倒计时定时器
    loading: 0,                           // 加载动画
    isMiniProgram: true,                   // 是否为小程序
    messageCount: 0                       // 消息数量
  },
  mutations: {
    common_time (state, val) {
      state.time = val
    },
    common_questions_time (state, val) {
      state.questions_time = state.questions_time - val
    },
    set_questions_time (state, val) {
      state.questions_time = val
    },
    common_timer_bol (state, val) {
      state.timer_bol = val
    },
    common_loading (state, val) {
      // if (val) {
      //   state.loading++
      // } else {
      //   state.loading--
      // }
      state.loading = val
    },
    common_isMiniProgram (state, val) {
      // state.isMiniProgram = val
      state.isMiniProgram = false
    },
    common_messageCount (state, val) {
      state.messageCount = val
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/common-store.js